import React, { Component } from 'react';
import './style.less';
import QRCode from 'qrcode.react';
import Load from '../Load/Load';

class WebPay extends Component {
    constructor(props){
        super(props);
        this.state = {
            sectionId:0
        }
    }
    tabFun(id,e){
        this.setState({
            sectionId:id,
            goodsNo:this.state.goodsInfo[id].goodsNo,
            totalAmount:this.state.goodsInfo[id].totalAmount
        })
    }
    componentWillReceiveProps(nextProps){
        this.setState({
            goodsInfo:nextProps.goodsInfo,
            goodsNo:(nextProps.goodsInfo[0]?nextProps.goodsInfo[this.state.sectionId].goodsNo:''),
            totalAmount:nextProps.goodsInfo[0]?nextProps.goodsInfo[this.state.sectionId].totalAmount:''
        })
    }
    render(){
        console.log(this.state)
        const _this = this;
        let sectionItem;
        if(this.props.goodsInfo.length) sectionItem = this.props.goodsInfo.map((ele,index)=>{
            return(
                <Section 
                    key={index}
                    num={ele.lessons} 
                    price={(ele.totalAmount)/100}  
                    selected={_this.state.sectionId===index && 'active'} 
                    clickFun={(e)=>this.tabFun(index,e)} 
                    expireDays={ele.expireDays}
                />
            )
        });
        return(
            <div className="container webpay">
                {this.props.completeRander &&
                    <React.Fragment>
                        <div className="top">
                            <div className="head">剩余课时<span>{this.props.lessonCnt || 0}</span>节</div>
                            {this.props.lessonDate && <div className="sub_head">有效期至：{this.props.lessonDate}</div>}
                        </div>
                        {this.props.goodsInfo.length &&
                            <div className="middle">
                                <div className="middle_left">
                                    {sectionItem}
                                </div>
                                <div className="middle_right">
                                    <div className='erweima'>
                                        <QRCode size={148} value={`https://client.aircourses.com/h5/paylink?userid=${this.props.userId}&goodsno=${this.state.goodsNo}`} fgColor='#20C8F2' />
                                    </div>
                                    <div className='text'>付款<span>{(this.state.totalAmount)/100 || 0}</span>元</div>
                                    <div className="text">请使用支付宝或微信扫码付款</div>
                                    {!window.location.href.indexOf("https") > -1 &&
                                        <div 
                                            className="pay_test" goodsno={this.state.goodsNo}
                                            onClick={()=>{this.props.payTest(this.state.goodsNo)}}
                                        >
                                            支付测试
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        {!this.props.goodsInfo.length &&
                            <div className="middle nolessons">
                                暂时没有可购买的课时
                            </div>
                        }
                    </React.Fragment>
                }
                {!this.props.completeRander &&
                    <Load />
                }
            </div>
        )
    }
}

const Section = props =>{
    return(
        <div className="section" onClick={props.clickFun}>
            <div className="section_left">
                <div>
                    <span className='num'>{props.num || 0}</span>
                    <span className='text'>课时</span>
                    <span className='price'>{props.price || 0}</span>
                    <span className='text'>元</span>
                </div>
                <div>
                    <span className='subtext'>
                        <span>有效期</span>
                        <span className='span'>{props.expireDays || 0}</span>
                        <span>天</span>
                    </span>
                </div>
            </div>
            <div className="section_right">
                <div className={props.selected || ''}></div>
            </div>
        </div>
    )
}

export default WebPay;



// WEBPACK FOOTER //
// ./src/template/Pay/WebPay.jsx